import { render, staticRenderFns } from "./LikeLink.vue?vue&type=template&id=41b55984&scoped=true"
import script from "./LikeLink.vue?vue&type=script&lang=js"
export * from "./LikeLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b55984",
  null
  
)

export default component.exports